export enum SortParam {
  Relevance = 0,
  PriceLowToHigh = 1,
  PriceHighToLow = 2,
}
export type SortParams = typeof SortParam[keyof typeof SortParam];
